<template>
    <v-container fluid grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12>
                <v-container fluid grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs3>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light">Quote History ({{ $format.int(pager.totalRecords) }})</h1>
                                <v-tooltip right>
                                    <template>
                                        <v-btn slot="activator" flat icon color="accent" class="mt-2" @click="onItemAdd"><v-icon>add_circle</v-icon></v-btn>
                                    </template>
                                    <span>Add a new quote</span>
                                </v-tooltip>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                            <v-btn color="accent" dark small right fab :loading="isBusy" class="el-m-t-10" @click="loadData">
                                <v-icon>autorenew</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs3 pt-3>
                            <v-layout row>
                                <v-menu open-on-hover bottom offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-chip label color="accent" text-color="white" v-on="on" class="forPerson"><v-icon left>filter_list</v-icon>{{ viewFor }}</v-chip>
                                    </template>
                                    <v-list>
                                        <v-list-tile v-for="(item, index) in viewForOptions" :key="index" @click="viewForClick(item)">
                                            <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                                <v-menu open-on-hover bottom offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-chip label :color="viewTypeColor" text-color="white" v-on="on" class="forQuote"><v-icon left>filter_list</v-icon>{{ viewType }}</v-chip>
                                    </template>
                                    <v-list>
                                        <v-list-tile v-for="(item, index) in viewTypeOptions" :key="index" @click="viewTypeClick(item)">
                                            <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-layout>
                        </v-flex>
                        <v-flex xs5>
                            <v-layout align-center justify-end row fill-height>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="toggleSearchAt">
                                            <v-icon>{{ searchAt.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Match search text at this position</span>
                                </v-tooltip>
                                <v-text-field ref="search" v-model="searchText" placeholder="Type here to filter the list" :hint="`(${searchAt.text}) Quote No, Acc No, Customer`" persistent-hint prepend-icon="search" clearable @keyup.native="searchChange" @click:clear="searchChange"></v-text-field>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-card>
                                <v-data-table :headers="headers" :items="tableData" :loading="isBusy" hide-actions disable-initial-sort>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <div>{{ props.item.QNo }}</div>
                                                <div class="f-m opa-6">{{ props.item.Acc }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.AccName }}</div>
                                                <div class="f-m opa-6">{{ props.item.Contact }}</div>
                                            </td>
                                            <td class="text-xs-right">
                                                <div>{{ $format.currency(props.item.Total) }}</div>
                                                <div class="f-m opa-6">Due: {{ $format.dateShort(props.item.DueDate) }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.Staff }}</div>
                                                <div class="f-m opa-6">{{ $format.dateTime(props.item.Dt) }}</div>
                                            </td>
                                            <td>
                                                <div :class="props.item.S_Id==='DRAFT'?'orange--text':''">{{ props.item.S_Id }}</div>
                                                <div :class="`f-m ${getStatusColor(props.item)}`">{{ getStatusText(props.item) }}</div>
                                            </td>
                                            <td class="justify-center layout px-0">
                                                <v-icon small class="mr-2 error--text text--darken-1" @click="onItemEdit(props.item)" v-if="props.item.HasRetryLog">info</v-icon>
                                                <v-icon small class="mr-2" @click="onItemEdit(props.item)">{{ props.item.S_Id === 'DRAFT' ? 'edit' : 'visibility' }}</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left">
                                        <v-pagination v-model="pager.currentPage" :length="pager.pages" :total-visible="7" @next="loadData" @previous="loadData" @input="loadData"></v-pagination>
                                    </div>
                                    <div class="pb-1 pl-2 el-float-right">
                                        <v-select v-model="pager.pageSize" :items="pageSizes" label="Page Size" dense hide-details style="max-width:80px;" @change="loadData"></v-select>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
        <v-dialog v-model="isDialogBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Processing...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Constants from '../../util/Constants';

export default {
    name: 'Quotes',
    props: {},
    data() {
        return {
            title: 'Quote History',
            user: { has: () => 0 },
            ViewCompany: {},
            viewFor: 'Mine',
            viewForOptions: [
                { title: 'Mine', text: 'My Quotes' },
                { title: 'All', text: 'Everybody\'s Quotes' }
            ],
            viewType: 'All',
            viewTypeOptions: [
                { title: 'All', text: 'All Quote Types' },
                { title: 'Done', text: 'Completed Quotes' },
                { title: 'Draft', text: 'Drafted Quotes' },
                { title: 'Pending', text: 'Pending Opera Submission' }
            ],
            viewTypeColor: 'accent',
            searchText: '',
            searchOptions: Constants.SEARCH_OPTIONS,
            searchAt: {},
            searchAtOptions: Constants.SEARCH_AT_OPTIONS,
            selected: null,
            headers: [
                { text: 'Quote No', value: 'QNo', align: 'left', width: '120px' },
                // { text: 'Account', value: 'Acc', align: 'left', width: '80px' },
                { text: 'Customer', value: 'AccName', align: 'left' },
                { text: 'Total', value: 'Total', align: 'right' },
                { text: 'Staff', value: 'Staff', align: 'left' },
                // { text: 'In Opera', value: 'IsOP', align: 'center', width: '80px' },
                // { text: 'Date', value: 'Dt', align: 'left' },
                { text: 'Status', value: 'S_Id', align: 'left', width: '120px' },
                { text: 'Action', value: 'S_Id', align: 'right', width: '110px', sortable: false },
            ],
            pager: {
                pageSize: 10,
                currentPage: 1,
                pages: 1,
                totalRecords: 0
            },
            sortField: { QNo: -1 },
            pageSizes: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100],
            isBusy: false,
            showDialog: false,
            isEditing: false,
            isDialogBusy: false,
            tableData: []
        };
    },
    mounted() {
        this.$root.$on('CompanySwitched', () => {
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            this.searchText = '';
            this.loadData();
        });

        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.pager.pageSize = this.$ls.get('PageSize_Quotes', 10);
        this.searchAt = this.searchAtOptions[2];
        this.viewFor = this.$ls.get('QuoteViewFor') || 'Mine';
        this.viewType = this.$ls.get('QuoteViewType') || 'All';
        switch (this.viewType) {
            case 'Draft':
                this.viewTypeColor = 'warning';
                break;
            case 'Pending':
                this.viewTypeColor = 'error';
                break;
            default:
                this.viewTypeColor = 'accent';
                break;
        }
        this.loadData();
        setTimeout(() => this.$refs.search.focus(), 250);
    },
    methods: {
        async loadData() {
            try {
                this.isBusy = true;
                this.searchText = this.searchText || '';
                const response = await this.$http.post('/Quote/list', { search: this.searchText.trim(), searchAt: this.searchAt.value, C_Id: this.ViewCompany._id, viewFor: this.viewFor, viewType: this.viewType, _page: { per: this.pager.pageSize, page: this.pager.currentPage }, _sort: this.sortField });
                this.pager.totalRecords = response.data.p.t;
                this.pager.pages = response.data.p.pt;
                this.tableData = response.data.d;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        toggleSearchAt() {
            let pos = this.searchAtOptions.indexOf(this.searchAt);
            pos += 1;
            if (pos === this.searchAtOptions.length) pos = 0;
            this.searchAt = this.searchAtOptions[pos];
            if (this.searchText.trim().length) {
                this.pager.currentPage = 1;
                this.loadData();
            }
            this.$refs.search.focus();
        },
        searchChange() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.pager.currentPage = 1;
                this.loadData();
            }, 600);
        },
        onItemAdd() {
            this.$router.push({ name: 'Quote' });
        },
        onItemEdit(row) {
            this.selected = row;
            this.$router.push({ name: 'Quote', query: { Q_Id: row._id } });
        },
        copyOne() {
            this.$alert({ type: 'info', title: 'Coming soon ...', message: 'This feature will be implemented soon.' });
        },
        copyAll() {
            this.$alert({ type: 'info', title: 'Coming soon ...', message: 'This feature will be implemented soon.' });
        },
        getStatusColor(rec) {
            if (rec.S_Id === 'DRAFT') return '';
            return rec.IsOP ? 'green--text' : 'error white--text';
        },
        getStatusText(rec) {
            if (rec.S_Id === 'DRAFT') return '-pending-';
            return rec.IsOP ? 'Opera Yes' : 'Opera NO!';
        },
        viewForClick(rec) {
            this.viewFor = rec.title;
            this.$ls.set('QuoteViewFor', this.viewFor);
            this.pager.currentPage = 1;
            this.loadData();
        },
        viewTypeClick(rec) {
            this.viewType = rec.title;
            this.$ls.set('QuoteViewType', this.viewType);
            switch (this.viewType) {
                case 'Draft':
                    this.viewTypeColor = 'warning';
                    break;
                case 'Pending':
                    this.viewTypeColor = 'error';
                    break;
                default:
                    this.viewTypeColor = 'accent';
                    break;
            }
            this.pager.currentPage = 1;
            this.loadData();
        }
    }
};
</script>

<style lang="scss" scoped>
.forPerson::after {
    content: "Staff";
    color: rgba(0,0,0,.54);
    font-size: 9pt;
    position: absolute;
    margin-top: 45px;
}
.forQuote::after {
    content: "Quote";
    color: rgba(0,0,0,.54);
    font-size: 9pt;
    position: absolute;
    margin-top: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Quote/QuoteList.vue